export const app = {
    apiKey: "AIzaSyBe5COsDAglknsrSN92yX_riDOiGZBZofU",
    authDomain: "mk8dx-cup-builder.firebaseapp.com",
    projectId: "mk8dx-cup-builder",
    storageBucket: "mk8dx-cup-builder.appspot.com",
    messagingSenderId: "835045502923",
    appId: "1:835045502923:web:599e5c5466b090f436d04e",
    measurementId: "G-96Q8J8PTY5"
};
